module.exports = __webpack_public_path__ + "assets/img/3_1390.19cb589d.jpg";